import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getOrderDetail(params) { // 获取订单详情
    return axios.post(global.IMS_ORDER + '/sales/findEcSaleOrderDetails', params)
  },
  findExchangeOrderDetails(params) { // 获取订单详情
    return axios.post(global.MMC_EXCHANGE + '/exchangOrder/findExchangeOrderDetails', params)
  },
  deliverConfirm(params) { // 确认收货
    return axios.post(global.IMS_ORDER + '/sales/confirmOrder', params)
  },
  cancelOrder(params) { // 取消订单
    return axios.post(global.IMS_ORDER + '/sales/cancelOrder', params)
  },
  deleteEcOrder(params) { // 删除订单
    return axios.post(global.IMS_ORDER + '/sales/deleteEcOrder', params)
  },
  insertReturn(params) { // 新增退货
    return axios.post(`${global.MSI_MIS}/return/insertReturn`, params)
  },
  cancelReturn(params) { // 取消退货
    return axios.post(`${global.MSI_MIS}/return/cancelReturn`, params)
  },
  findReturnItem(params) { // 查询退货单详情
    return axios.post(`${global.MSI_MIS}/return/findReturnItem`, params)
  },
  deleteReturn(params) { // 删除退货
    return axios.post(`${global.MSI_MIS}/return/deleteReturn`, params)
  },
  findCompanyInfo(params) { // 查询公司银行信息
    return axios.post(`${global.IMS_ORDER}/sales/findCompanyInfo`, params)
  },
  submitReturn(params) { // 退货
    return axios.post(`${global.MSI_MIS}/return/submitReturn`, params)
  },
  confirmPay(params) { // 确认付款
    return axios.post(`${global.FINANCE_PAY}/confirmReceipt`, params)
  },
  findAllAccountAsp(params) { // 查询账户列表
    return axios.post(`${global.ACCOUNT}/findAllAccountAsp`, params)
  }
}



// WEBPACK FOOTER //
// ./src/request/member/order.js